import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { connectedBlueprintsVM } from '../blueprints.context';
import { OrderTemplatesPresentation } from './order-templates.presentation';
import { OrderTemplatesVM } from './order-templates.viewmodel';

export type ContainerProps = {
    accountId: number;
};

const OrderTemplatesContainer = withViewModel(
    OrderTemplatesPresentation,
    ({ accountId }: ContainerProps) => {
        const orderTemplatesVM = new OrderTemplatesVM(accountId);

        orderTemplatesVM.initialize();

        return orderTemplatesVM;
    },
    props => [ props.accountId ]
);

export const OrderTemplates = connectedBlueprintsVM<ContainerProps>(
    OrderTemplatesContainer,
    vm => ({
        accountId: vm.getAccountId(),
    })
);
